/**
 * Accounts Matcher API client. Mirrors the three /api/accounts-matcher
 * routes; types come from `@pfh/shared/api/accounts-matcher`.
 */

import type {
  CalculateReq,
  CalculateRes,
  ListIfAccountsRes,
  ListIfPairsRes,
} from "@pfh/shared";
import { api } from "../api";

export type {
  AccountRiskConfigDTO,
  CalculateReq,
  CalculateRes,
  DerivedAccountRiskDTO,
  IfAccountSummary,
  IfPairSummary,
  ListIfAccountsRes,
  ListIfPairsRes,
  PairDerivedRiskDTO,
} from "@pfh/shared";

export async function listIfAccounts(): Promise<ListIfAccountsRes> {
  return api.get<ListIfAccountsRes>("/api/accounts-matcher/if-accounts");
}

export async function listIfPairs(): Promise<ListIfPairsRes> {
  return api.get<ListIfPairsRes>("/api/accounts-matcher/if-pairs");
}

export async function calculatePairRisk(req: CalculateReq): Promise<CalculateRes> {
  return api.post<CalculateRes>("/api/accounts-matcher/calculate", req);
}
